"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _kycJumioActions = require("../../redux/actions/kycJumioActions");
var _kycLevelsSelectors = require("../../redux/selectors/kycLevelsSelectors");
var _KYCSumSubSdk = _interopRequireDefault(require("./KYCSumSubSdk"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var kycData = (0, _kycLevelsSelectors.kycVerificationLevelsSelector)(state);
  var verificationLevel = kycData.verificationLevel,
    kycConfig = kycData.kycConfig;
  return {
    kycConfig: kycConfig,
    verificationLevel: verificationLevel
  };
};
var mapDispatchToProps = {
  validateUserRegistration: _kycJumioActions.validateUserRegistration
};
var KYCSumSubSdkContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_KYCSumSubSdk["default"]);
var _default = exports["default"] = KYCSumSubSdkContainer;